module.exports = __webpack_public_path__ + "static/3-edee58338c1b8e17f79f4e7b48cd0623.png";